// extracted by mini-css-extract-plugin
export default {"root":"QrmG_f"};